import {
  PlanEntitlement,
  PlanEntitlementKey,
} from '../../api/graphql/generated';

export function hasEntitlement(options: {
  entitlements: Array<PlanEntitlement>;
  key: PlanEntitlementKey;
}): boolean {
  const { entitlements, key } = options;

  const entitlement = entitlements.find((e) => e.key === key);

  let hasEntitlement = false;

  if (entitlement !== undefined) {
    // Generally, the existence of an entitlement means
    // that the user has it. However, some entitlement values
    // are booleans which explicitly grant or deny access.
    // If the value is NOT 'false' then assume they have it.
    hasEntitlement = entitlement.value !== 'false';
  }

  return hasEntitlement;
}
